'use es6';
/*
 * USER specific
 */

import { User as attrApi } from 'DesignData/api/attributes';
import { DESIGN_MANAGER_USER_SETTINGS } from 'DesignData/enums/attributes/User';
/**
 * @param {Number} userId
 * @param {Object} settings
 * @returns {Promise}
 */

export function saveUserSettings(userId, settings) {
  return attrApi.save(DESIGN_MANAGER_USER_SETTINGS, settings);
}